import {createAction} from "redux-act";
import {
	IContest,
	ISaveQuestionPayload,
	IServerPrediction,
	IPlayerStatMapperEntity,
	IShowMyResponse,
	Nullable,
} from "modules/types";

export const fetchContestsRequest = createAction();
export const fetchContestsSuccess = createAction<IContest[]>();

export const gameStart = createAction();
export const setActiveQuestion = createAction<IServerPrediction>();
export const setCurrentQuestionIndex = createAction<number>();
export const pushPlayerToCardsArray = createAction<number>();
export const setGameStarted = createAction<boolean>();

export const answerQuestion = createAction<ISaveQuestionPayload>();
export const putPlayerStat = createAction<IPlayerStatMapperEntity>();
export const toggleTimerVisibility = createAction<boolean>();
export const setIsButtonsDisabled = createAction<boolean>();
export const gameOver = createAction();

export const fetchContestResultsRequest = createAction<number>();
export const fetchContestResultsSuccess = createAction<IShowMyResponse>();
export const fetchContestResultsClear = createAction();

export const addPointToScore = createAction();
export const addPointToStrikes = createAction();

export const clearContestPointsRequest = createAction();
export const clearContestPointsSuccess = createAction();

export const setTimerTime = createAction<Nullable<number>>();
export const setTimerTimeLimit = createAction<Nullable<number>>();
export const setAmtStrikes = createAction<number>();
